module.exports = __webpack_public_path__ + "static/media/redirectToPiIcon.de12efe2.svg";